import {
    lineOptions,
    polygonOptions,
} from 'app/agriculture/forms/components/ShapeEditor/icons/ShapeEditorGraphics';
import { PrimitiveCollectionProvider } from 'app/agriculture/FarmMain/MapRenderer/context/PrimitiveCollectionContext';
import { CesiumPolylineComponent } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumPolylineComponent';
import { CesiumPolygonComponent } from 'app/agriculture/FarmMain/MapRenderer/components/CesiumPolygonComponent';
import { ShapeEditorMachineContext } from 'app/agriculture/forms/components/ShapeEditor/ShapeEditorMachine';

interface ShapeEditorPolygonRendererProps {
    points?: Cesium.Cartesian3[];
    isEditing: boolean;
    mode: ShapeEditorMachineContext['mode'];
}

export function ShapeEditorPolygonRenderer({
    points,
    isEditing,
    mode,
}: ShapeEditorPolygonRendererProps) {
    if (points == null) return null;

    return (
        <PrimitiveCollectionProvider>
            {mode === 'Polygon' && points.length > 2 && isEditing ? (
                <CesiumPolygonComponent positions={points} {...polygonOptions} />
            ) : null}
            {points.length > 1 ? (
                <CesiumPolylineComponent positions={points} {...lineOptions} />
            ) : null}
        </PrimitiveCollectionProvider>
    );
}
